import AddIcon from '@mui/icons-material/Add'
import CheckIcon from '@mui/icons-material/Check'
import {
  Button,
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from '@mui/material'
import { useCallback, useState } from 'react'

import { EntryWithRelated } from '../../models/inspections'
import { CannedJobExpanded } from '../../sdk'
import theme from '../../styles/theme'
import {
  INITIAL_SELECTED,
  SelectedJob
} from '../Estimates/useLookupServiceDialog/transformSelectedJob'
import { useSubmitCannedJobOrMotor } from '../Estimates/useLookupServiceDialog/useSubmitCannedJobOrMotor'
import { LoadingBackdrop } from '../SharedUI/LoadingBackdrop'

export const SingleEntryRecommendedCannedJob = ({
  cannedJob,
  cannedJobsInService
}: {
  cannedJob: CannedJobExpanded
  cannedJobsInService: Set<string>
  inspectionEntry: EntryWithRelated
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { submitCannedJobAndMotor } = useSubmitCannedJobOrMotor()

  const handleSubmit = useCallback(
    async (selected: SelectedJob) => {
      // create stands alone service item
      try {
        setIsSubmitting(true)
        await submitCannedJobAndMotor(selected)
      } finally {
        setIsSubmitting(false)
      }
    },
    [submitCannedJobAndMotor]
  )
  return (
    <>
      {isSubmitting && <LoadingBackdrop />}
      <ListItem
        key={cannedJob.entry!.id!}
        sx={{ bgcolor: theme.palette.grey[200], borderRadius: 2, marginY: 1 }}>
        <ListItemText primary={cannedJob.entry!.info!.name || ''} />
        <ListItemSecondaryAction>
          {cannedJobsInService.has(cannedJob.entry!.id!) ? (
            <CheckIcon color="success" />
          ) : (
            <Button
              startIcon={<AddIcon />}
              size="small"
              onClick={() =>
                handleSubmit({
                  ...INITIAL_SELECTED,
                  canned: [{ ...cannedJob, unSelected: new Set() }]
                })
              }>
              Add to Repair Order
            </Button>
          )}
        </ListItemSecondaryAction>
      </ListItem>
    </>
  )
}
